/**
 * Dev mode → Knowledge (SUN-78, mockups/kiaan-knowledge.html). Admin only (kiaan_manage_knowledge).
 *   Graph       — containers / branches / files / chat memories; pick one thing and remove exactly it.
 *   Chat memory — per agent: forget one line, one chat, or everything it remembers.
 *   Rejected    — files the automatic check refused (hidden AI instructions, personal IDs, prices that
 *                 do not match the catalogue), with the reasons. They were never stored (SUN-89).
 *   Drop a folder — the existing sort → check → save flow; it ends on the graph showing that import.
 * Who-may-read-what by role lives in Settings → Users & Roles → Knowledge access.
 */
import { useState } from 'react';
import { KnowledgeUpload } from './KnowledgeUpload';
import { KnowledgeGraph } from '../knowledge/KnowledgeGraph';
import { ChatMemory } from '../knowledge/ChatMemory';
import { RejectedList } from '../knowledge/RejectedList';
import '../knowledge/knowledge.css';

export const KNOWLEDGE_ADMIN_ONLY = 'Only admins who manage knowledge can open this.';

type View = 'graph' | 'memory' | 'rejected' | 'upload';

export function Knowledge({ canManage }: { canManage: boolean }) {
  const [view, setView] = useState<View>('graph');
  const [since, setSince] = useState<string | null>(null);
  const [memAgent, setMemAgent] = useState<string | null>(null);

  if (!canManage) return <div className="kw-banner" role="status">{KNOWLEDGE_ADMIN_ONLY}</div>;

  if (view === 'upload') {
    return <KnowledgeUpload onDone={(importId) => { setSince(importId ?? null); setView('graph'); }} />;
  }

  return (
    <div className="kn-wrap">
      <div className="kn-subtabs" role="tablist" aria-label="Knowledge">
        <button type="button" role="tab" aria-selected={view === 'graph'} onClick={() => setView('graph')}>Graph</button>
        <button type="button" role="tab" aria-selected={view === 'memory'} onClick={() => setView('memory')}>Chat memory</button>
        <button type="button" role="tab" aria-selected={view === 'rejected'} onClick={() => setView('rejected')}>Rejected</button>
      </div>
      {view === 'graph' && (
        <KnowledgeGraph since={since} onUpload={() => setView('upload')} onOpenMemory={(agentId) => { setMemAgent(agentId); setView('memory'); }} />
      )}
      {view === 'memory' && <ChatMemory agentId={memAgent} />}
      {view === 'rejected' && <RejectedList />}
    </div>
  );
}
